<div id="scholarship" data-scroll>
  <div class="container">
      <div class="row">
          <div class="col-12 col-md-6 col-lg-6 mt-4 border-rt border-bt">
              <h2 class="font-weight-bold text-center" data-scroll>
                Awards and Scholarships
              </h2>
              <!-- <h5 class="text-center">Awards and Scholarships</h5> -->
              <!-- <h6 class="text-center">Proud Moment for Springdale Public School</h6> -->
              <p class="pt-2" data-scroll>Students are motivated through awards and scholarship for meritorious progress in studies, excellence in co-curricular and extracurricular activities.
              </p>
              <h6 class="text-center">Nine awards have been instituted in the names of very respected members of the Kshatriya Sabha and local community.Listed Below:</h6>
          </div>
          <div class="col-12 col-md-6 col-lg-6 mt-4 pl-lg-5 my-auto">
              <!-- <h2 class="font-weight-bold" data-scroll>
                
              </h2> -->
              <!-- <p class="pt-2" data-scroll> To provide student global exposure, we at GNKITM provide golden opportunity to study abroad. Malta is a country that values the importance of university graduates. Skilled graduates who stay or move to Malta can benefit from tax breaks, fast-track visas, and free support to help start a new business. </p> -->
              <div id="achievementCarousel" class="carousel slide" data-ride="carousel">
                  <div class="carousel-inner">
                    <div class="carousel-item" *ngFor="let img of imgUrl, let i=index" [ngClass]="(i == 0 ) ? 'active' : ''">
                      <img appLazyload [src]="img" class="d-block w-100 rounded" alt="Achievements" >
                    </div>
                  </div>
                 <button class="carousel-control-prev" type="button" data-target="#achievementCarousel" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-target="#achievementCarousel" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                  </button>
                </div>
          </div>
      </div>
  </div>
</div>

<div id="part-2">
  <div class="container">
      <div id="firstCarousel" class="carousel slide" data-ride="carousel">
          <ol class="carousel-indicators">
              <li data-target="#firstCarousel" data-slide-to="0" class="active"></li>
              <li data-target="#firstCarousel" data-slide-to="1"></li>
            
            </ol>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="row">
                  <div class="col-12 col-md-6 col-lg-2 border-2">
                      <p class="px-1" >Pt. Moti Ram memorial award </p>
                      <!-- <h6 class="font-weight-bold">Kalpana Chawla</h6> -->
                      <hr >
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 border-3">
                      <p class="px-1" >Thakur Gaze Singh (Chanalheri) Memorial Award</p>
                      <!-- <h6 class="font-weight-bold">Dr. APJ Abdul Kalam</h6> -->
                      <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 border-2">
                      <p class="px-1" >Smt. Shanti Devi Pawar Memorial Award</p>
                      <!-- <h6 class="font-weight-bold">Swami Vivekanand</h6> -->
                      <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-2 border-2">
                      <p class="px-1" > Sh. O.P.S. Memorial Award</p>
                      <!-- <h6 class="font-weight-bold">Mother Teresa</h6> -->
                      <hr>
                      </div>
                      <div class="col-12 col-md-6 col-lg-2 ">
                        <p class="px-1" >Smt. Angoori Devi Memorial Award</p>
                        <hr>
                    </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="row">
                 
                  <div class="col-12 col-md-6 col-lg-3 border-2">
                      <p class="px-1" >The Munjal Memorial Award</p>
                      <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 border-3">
                      <p class="px-1" >Smt. Sona Devi & Sh. Bharat Singh Tanwar Memorial Award</p>
                      <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 border-2">
                      <p class="px-1" > Smt. Ramdevi and Sh. Sundar Singh Memorial Award </p>
                      <hr>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3">
                    <p class="px-1" > Kumari Shubhra Tanwar Memorial Award </p>
                    <hr>
                </div>
              </div>
            </div>
          
          </div>
        </div>
     
  </div>
</div>



<!-- <div id="acheivements">
  <div class="container">
      <div class="row" id="part1">
          <div class="col-lg-6 col-md-12">
              <div id="heading">
                  <h2>ACHEIVEMENTS</h2>
                  <p>A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart like mine.</p>
                  <img src="/assets/img/showcase/1.jpg" alt="Acheivents" class="img-fluid">
              </div>
          </div>
          <div class="col-lg-6 col-md-12 text-center" id="ach-detail">
              <div class="row">
                  <div class="col-lg-6 col-md-6">
                      <div class="border">
                          <span class="counter">80</span>
                          <h4>TEACHERS</h4>
                      </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                      <div class="border">
                          <span class="counter">20</span>
                          <h4>COURSES</h4>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-lg-6 col-md-6">
                      <div class="border">
                          <span class="counter">1500</span>
                          <h4>STUDENTS</h4>
                      </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                      <div class="border">
                          <span><span class="counter">5000</span>+</span>
                          <h4>SATISFIED PARENTS</h4>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div> -->



<!-- <div class="parallax">
    <h1 data-scroll>Parallax Effect</h1> 
  </div>
  
  <div class="parallax p-2">
    <h1 data-scroll>I’m at a place in my life when errands are starting to count as going out.</h1> 
  </div>
  
  <div class="parallax p-3">
    <h1 data-scroll>I don’t believe in astrology;<br> I’m a Sagittarius and we’re skeptical.</h1> 
  </div> -->